import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import Product from '../../domain/Product';
import Amount from '../../domain/Amount';
import SponsorDomain from '../../domain/Sponsor';
import Registered from '../../domain/Registered';
import Color from '../../domain/Color';
import User from '../../domain/User';
import Reducer from '../../domain/Reducer';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import Console from '../../components/Console';
import UserHeader from '../../components/header/User';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  user: User,
  product: Product,
  sponsor: t.maybe(SponsorDomain),
  reducer: Reducer,
  context: t.Obj,
  like_url: t.Str,
  gplus_url: t.Str,
  go_product: t.Func,
  do_reduce: t.Func,
  do_skip: t.Func,
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  bgColor: t.maybe(Color),
  goAccount: t.Func,
  goPurchases: t.Func,
  goChangePassword: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.maybe(t.Func),
  partners: t.maybe(t.Obj),
  goBuildOrder: t.maybe(t.Func),
  oldPrice: t.maybe(t.Num),
  goPurchase: t.Func
})
export default class ReducerView extends React.Component {

  constructor(...args){
    super(...args);

    const do_reduce = (value) => {
       this.props.do_reduce(value);
    };
    const do_skip = () => {
       this.props.do_skip();
    };

    const getStyleBtnColor = () => {
      return 'style="background-color:' + this.props.themeBtnColor + '; color:' + this.props.themeBtnFontColor + '"'; //, color:"' + this.props.themeBtnFontColor + '"'
    };

    const reducer_sandbox = {
      locale: this.props.locale,
      like_url: this.props.like_url,
      gplus_url: this.props.gplus_url,
      context: this.props.context,
      default_privacy: this.props.sponsor ? this.props.sponsor.privacy : null,
      do_reduce: do_reduce,
      do_skip: do_skip,
      styleBtnColor: getStyleBtnColor()
    };

    this.state = {
      reducer: this.props.reducer.to_widget(reducer_sandbox)
    };
  }

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getListPrice() {
    return Amount.format(this.props.locale, this.props.product.currency, this.props.product.list_price);
  }

  getSponsor() {
    const options = {
      is_welcome: Registered.is(this.props.user),
      showTutorial: false
    };

    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getReducerContent() {
    return <div dangerouslySetInnerHTML={{__html: this.state.reducer.to_html()}}></div>;
  }

  componentDidMount() {
    this.state.reducer.start();
  }

  componentWillUnmount() {
    this.state.reducer.stop();
  }

  getHeader() {
    return (
      <UserHeader
        locale={this.props.locale}
        goAccount={this.props.goAccount}
        goPurchases={this.props.goPurchases}
        goChangePassword={this.props.goChangePassword}
        doLogout={this.props.doLogout}
        goProduct={this.props.go_product}
        user={this.props.user}
        color={this.getColor()}
        themeBtnColor={this.props.themeBtnColor}
        themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  getProductName() {
    return  (<h2 className='large-text-center' >{this.props.product.name}</h2>);
  }

  getReducer() {
    const {locale, themeBgColor, themeBgFontColor} = this.props;
    const bundle = get_bundle(locale).reducer;

    const styleBgColor = {
      backgroundColor: themeBgColor,
      color: themeBgFontColor
    };
    const styleBorderRxColor = {
      borderRightColor: themeBgColor
    };

    const triangleLeft = <div className='triangle-left medium-hide' style={styleBorderRxColor}></div>;
    /* {triangleLeft} */
    return (
      <div className='cell'>
        <div id='reducer_container'>
          <div id='reducer_title' className='box dark' style={styleBgColor}>
            <h1 className='large-text-center' >{bundle.title}</h1>
            {this.getProductName()}
          </div>
          { this.getReducerContent() }
        </div>
      </div>
    );
  }

  getConsole() {
    const { product, locale } = this.props;
    const doShowBonus = false;
    const doShowTimeAgo = true;
    const doShowConsole = true;
    return (
      <div className='cell'>
        <Console
          doShowConsole={doShowConsole}
          locale={locale}
          themeBgColor={this.props.themeBgColor}
          themeBtnColor={this.props.themeBtnColor}
          themeBgFontColor={this.props.themeBgFontColor}
          themeBtnFontColor={this.props.themeBtnFontColor}
          // message={this.props.message}
          product={product}
          goBuildOrder={this.props.goBuildOrder}
          goPurchase={this.props.goPurchase}
          // doReduce={this.props.doReduce}
          oldPrice={this.props.oldPrice}
          doShowBonus={doShowBonus}
          doShowTimeAgo={doShowTimeAgo}
          doShowProductName={false}
          doShowArrowRight />
      </div>
    );
    /*return (
      <div className='cell'>
        <div id='reducer_product'>
          <div className='cell'>
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <h3><del>{this.getListPrice()}</del></h3>
          </div>
          <img src={product.image}/>
        </div>
      </div>
    );*/
  }

  getProductBox() {
    const { product } = this.props;
    return (
      <div className='cell'>
        <div id='reducer_product'>
          <img src={product.image}/>
          <div className='cell'>
            <h3>{product.name}</h3>
            <p>{product.description}</p>
          </div>
        </div>
      </div>
    );
  }

  getSmallLayout() {
    return (
      <div className='small-100'>
        {this.getConsole()}
        {this.getReducer()}
        {this.getProductBox()}
      </div>
    );
  }

  getLargeLayout() {
    return (
      <div className='large-100'>
        <div className='large-30'>
          {this.getConsole()}
          {this.getProductBox()}
        </div>
        <div className='large-70'>
          {this.getReducer()}
        </div>
      </div>
    );
  }

  getReducerLayoutOld() {
    return (
      <div>
        <div className='large-100 small-hide'>
          {this.getLargeLayout()}
        </div>
        <div className='small-100 small-show large-hide'>
          {this.getSmallLayout()}
        </div>
      </div>
    );
  }

  getReducerLayout() {
    return (
      <div>
        <div className='large-30 small-100'>
          {this.getConsole()}
          <div className='small-hide'>
            {this.getProductBox()}
          </div>
        </div>
        <div className='large-70 small-100'>
          {this.getReducer()}
        </div>
        <div className='small-100 small-show large-hide'>
          {this.getProductBox()}
        </div>
      </div>
    );
  }

  render() {
    const {locale} = this.props;

    return (
      <Layout header={this.getHeader()} partners={this.props.partners} sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id='reducer'>
          <div className='cols'>
            {this.getReducerLayout()}
          </div>
        </div>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/Reducer.js
 **/